import i18n from 'core/InitialiseThirdParties/i18n';

export const computePrice = (translate: typeof i18n, price: number, currency: string) =>
    new Intl.NumberFormat(translate.language, {
        style: 'currency',
        currency,
    }).format(price / 100);
